/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { PolarisProductDatesSettingsEntrypointProps } from './polarisProductDatesSettings.entrypoint.types.tsx';

type PolarisProductDatesSettingsEntryPointComponent = EntryPointComponent<
	{},
	{},
	PolarisProductDatesSettingsEntrypointProps,
	{} | null
>;

export const polarisProductDatesSettingsEntryPoint: EntryPoint<
	PolarisProductDatesSettingsEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<PolarisProductDatesSettingsEntryPointComponent>(
		/* webpackChunkName: "async-polaris-settings-dates", jiraSpaEntry: "async-polaris-ideas" */ './index.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
});
